import React from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sends a crash report to the backend so production errors can be diagnosed (best-effort, never throws).
export const reportClientError = (error, context = "") => {
  try {
    axios
      .post(`${API}/client-errors`, {
        message: String(error?.message || error || "").slice(0, 500),
        stack: String(error?.stack || "").slice(0, 4000),
        context: String(context).slice(0, 200),
        url: window.location.href.slice(0, 500),
        user_agent: navigator.userAgent.slice(0, 300),
      })
      .catch(() => {});
  } catch {
    /* ignore */
  }
};

// Isolates a widget: if it crashes, only the widget is replaced (never a blank page).
class SafeBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Widget error:", error);
    reportClientError(error, `${this.props.name || "widget"} ${info?.componentStack?.slice(0, 300) || ""}`);
  }

  render() {
    if (this.state.failed) return this.props.fallback || null;
    return this.props.children;
  }
}

export default SafeBoundary;
